export default __webpack_public_path__ + "static/media/minus.646f7515.svg";